import React from 'react';
import {
  demoInterestsList,
  demoLessons, getInterestsFromLink, goToResults,
  Lesson,
  searchByInterests
} from '../api/lessons';
import LessonsList from "../components/Lists";
import Footer from '../components/Footer';
import Navbar from "../components/Navbar";
import { MuiThemeProvider, Theme, createStyles, withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { theme } from '../App';

interface Props {
  classes: any;
  query: any;
  history: any;
}

interface State {
  value: number;
  lessons: Lesson[];
  interests: string[];
  age: number;
}

class LandingView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: 0,
      lessons: demoLessons,
      interests: [],
      age: 12,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
  }

  handleChange = (event: any, value: number) => {
    this.setState({ value });
  }

  handleChangeIndex = (index: number) => {
    this.setState({ value: index });
  }

  updateInterests = () => {
    // @ts-ignore
    let query = new URLSearchParams(this.props.location.search);
    // @ts-ignore
    let interests: string[] = getInterestsFromLink(query.get("interests"))
    if (this.state.interests.toString() !== interests.toString()) {
      this.setState({interests: interests})
    }
  }

  updateLessons = () => {
    let lessons = searchByInterests(demoLessons, this.state.interests, this.state.age)
    if (lessons.length === 0) lessons = demoLessons;
    if (this.state.lessons.toString() !== lessons.toString()) {
      this.setState({lessons: lessons})
    }
  }

  render() {
    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
      goToResults(event.target.value as string[], this.props.history)
    };

    const getStyles = (name: string) => {
      return {
        fontWeight:
          this.state.interests.indexOf(name) === -1
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
      };
    }
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: 48 * 4.5 + 8,
          width: 250,
        },
      },
    };

    this.updateInterests()
    this.updateLessons()
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline/>
        <Navbar page="results" />
        <main className={classes.root}>
          <section>
            <Container maxWidth="md">
              <Typography variant="h3" color="textPrimary">
                Занятия:
              </Typography>
              <FormControl className={classes.formControl}>
                <InputLabel id="interests-label" color="secondary">
                  {this.state.interests.length === 0 ? "Выберите интересы" : "Интересы"}
                </InputLabel>
                <Select
                  labelId="interests-label"
                  id="interests-select"
                  multiple
                  value={this.state.interests}
                  onChange={handleChange}
                  input={
                    <Input
                      id="interests-chip"
                      color="secondary"
                    />
                  }
                  color="secondary"
                  renderValue={(selected) => (
                    <div className={classes.chips}>
                      {(selected as string[]).map((value) => (
                        <Chip key={value} label={value} className={classes.chip} />
                      ))}
                    </div>
                  )}
                  MenuProps={MenuProps}
                >
                  {demoInterestsList.map((name) => (
                    <MenuItem key={name} value={name} style={getStyles(name)}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <LessonsList max={5} lessons={this.state.lessons} history={this.props.history}/>
              <div className={classes.center}>
                <Button size="small" onClick={()=>this.props.history.push("/results")}>Показать все</Button>
              </div>
            </Container>
          </section>
        </main>
        <Footer />
      </MuiThemeProvider>
    );
  }
}

const style = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "center",
      minWidth: 480,
      minHeight: "90vh",
      marginTop: theme.spacing(4),
    },
    center: {
      display: "flex",
      justifyContent: "center",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 220,
      maxWidth: 480,
    },
  }
);

export default withStyles(style)(LandingView);
